<template>
    <div>
        <toast-message
            :message="errmsg"
            type="error"
            :isToastEnable="toast"
            @close="(val) => toast = val"
        />
        <div>
            <div class="download-btn marginbot-20">
              <download-button @downloadTemplate="downloadTemplate" >
                </download-button>
            </div>
            <div class="margin-t-15px" :key="componentKey">
              <upload :tobucket="false" @change="onUploadTemplate($event)"></upload>
            </div>
        </div>
        <pop-up-message
                v-if="showSuccessMsg"
                message="File uploaded Successfully."
                btnText="OK"
                @back="goToBack()"
            ></pop-up-message>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
    data() {
        return{
            showSuccessMsg: false,
            componentKey: 0,
            toast: false,
            errmsg: ""
        }
    },
    computed: {
        ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID"
    }),
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      } else {
        return this.getLegalEntityId(0);
      }
    },
    },

    methods: {
      ...mapActions({
        act_download_bulk_fnf_revoke: 'dashboard/organisation/processfnf/getBulkRevokeTemplate',
        act_upload_bulk_fnf_revoke: 'dashboard/organisation/processfnf/uploadFnfRevokeTemplate',
    }),

    async downloadTemplate() {
      try {
        let payload = {
          le_id: this.leId,
        }
        let res = await this.act_download_bulk_fnf_revoke(payload);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async onUploadTemplate(event) {
      //   let currentMonthEnum = this.financialMonthOptions.find(
      //   item => item.name == this.monthOptions[new Date().getMonth()]
      // ).value;
      let formData = new FormData();
      formData.append("file", event);
      formData.append("le_id", this.leId);

      this.$root._data.isSaving = true;
      try {
        let res = await this.act_upload_bulk_fnf_revoke(formData);
        if (res.status) {
            console.log("entry");
          this.showSuccessMsg = true;
          this.componentKey += 1;
        }
        setTimeout(() => {
          this.$root._data.isSaving = false;
        }, 500);
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
        this.componentKey += 1;
      }
    },

    goToBack() {
      this.showSuccessMsg = false;
      this.$emit('refreshPending')
    },
    },
}
</script>